<template>
<div class="section-inn content walletHist" :id="props.id">
  <div class="cashbox-filter"><form @submit.prevent>
    
    <div class="cashbox-filter__inner">

      <div class="cashbox-filter__line">
        Период

        <Dpick placeholder="с" :value="vals.beg" @change="set_val('beg', $event)" />

        <Dpick placeholder="до" :value="vals.end" @change="set_val('end', $event)" />

      </div>

      <div class="cashbox-filter__line">
        Номер заявки 
        <Nomerpick placeholder="9999999" v-model="nomer" />
      </div>

      
      <div v-if="isError" class="cashbox-filter__line" style="padding:10px; background: #ffaaaa">Данные не получены!</div>
      
      <div class="cashbox-filter__line">
        <button class="cashbox-filter__btn" @click="reset">сбросить фильтр</button>
      </div>

      <div><a target="_blank" :href="excel_link">Экспорт в EXCEL</a></div>
      
    </div>
    
  </form></div>

  <table class="cashbox-table">
    <thead>
      <tr>
        <th>
          <template v-if="wait">
            <Dots v-if="wait" class="cashbox__dots" />
          </template>
          <template v-else>
            дата
          </template>
        </th>
        <th>
          <template v-if="wait">
            <Dots v-if="wait" class="cashbox__dots" />
          </template>
          <template v-else>
            детали
          </template>
        </th>
        <th>приход</th>
        <th>расход</th>
        <th>баланс</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="op in operations">
        <td>{{dmy(op.date)}}</td>
        <td>
          {{op.detail}}
          <a v-if="op.claim_id" :href="claim_link(op)">{{op.claim_num}}</a>
          {{op.corp_str}} 
        </td>
        <td>{{price3rub(op.income)}}</td>
        <td>{{price3rub(op.expend)}}</td>
        <td>{{price3rub(op.balance)}}</td>
      </tr>
    </tbody>
  </table>
  <div class="cashbox-pagination">
    <button class="cashbox-pagination__btn" @click="page_next" :disabled="page_next_disabled">показать еще</button>
    <button class="cashbox-pagination__btn" @click="page_all" :disabled="page_all_disabled">показать все</button>
    <span v-if="wait" class="loadi"></span>
  </div>
</div>
</template>



<style lang="sass" src="./Hist.scss"></style>


<script setup>
import { ref, computed, watch } from 'vue'
import { price3rub as price3rubMisc, slow_deep_clone as deep_clone } from '../misc.js'
import { walletHist, walletHist2pars  } from '@/actions.js'
import Dpick from './Dpick.vue'
import Nomerpick from './Nomerpick.vue'
import Dots from '@/comp/Login/three-dots.vue'

const props = defineProps({
    id : String,
}) 



const start_vals = () => {
  return {
    "show_all": false, // переключатель или кнопка показать все
    "offset": 0, // когда жмем показать еще - увеличивается
    "limit": 20,
    "beg": '', // период с
    "end": '', // период по
    "nomer": '', // фильтр по номеру заявки
  }
}


const vals=ref( start_vals() ) // ref(deep_clone(start_vals))

const isError=ref(false)
const has_next_page=ref(true) // есть смысл нажимать далее
const operations=ref([])
const reset_key=ref(0) // при повышении сбрасываем зависимые
const abort=ref(null)


const nomer = computed({
    get() {
        return vals.value.nomer
    },
    set(value) {
      vals.value.nomer = value
    }
})


const wait=computed(function() {// ждать ли новой порции данных
    return abort.value ? true : false;
})

const page_all_disabled=computed(function() {
    return wait.value || vals.value.show_all;
})

const page_next_disabled=computed(function() {
    return wait.value || vals.value.show_all || !has_next_page.value;
})

const excel_link=computed(function() {
    /*
    https://eto.sereniti.ru/ajax/list/apaoperation.php?f_apaop_period=
        f_apaop_register=1
        f_apaop_register_2=
        f_apaop_bplace=
        f_apaop_division=
        f_apaop_agroup=
        f_apaop_date_beg=01.03.2021
        f_apaop_date_end=26.03.2021
        f_apaop_direction=
        f_apaop_proc=
        f_apaop_corp=
        f_apaop_attach=
        cmd=operations
        sort=
        export=1
        format=pdf
    */
    const ob=new URL(`${location.protocol}//${location.host}/ajax/list/apaoperation.php`)
    ob.searchParams.set('cmd','operations')
    ob.searchParams.set('format','xls')
    ob.searchParams.set('export','1')
    ob.searchParams.set('f_apaop_register', '1')
    const data=walletHist2pars(vals.value)
    Object.keys(data).forEach(key => ob.searchParams.set(key, data[key]))
    const ret=ob.toString()
    return ret
})

function dmy(ymd) {// 2021-06-27 27.06.2021
    let ret='-'
    if (ymd) {
        let a=ymd.split('-')
        ret=`${a[2]}.${a[1]}.${a[0]}`
    }
    return  ret
}

function price3rub(x) {
    return x ? price3rubMisc(x, true) : '' 
}

function load_n_vals(pars, abort) {
    return walletHist(pars, abort).then(
        data => { return {data: data, vals: pars } }
    ).catch(
        rej => {  return Promise.reject( {rej: rej, vals: pars }  )  }
    );
}

function claim_link(op) {
    return `/workspace/tours/?id=${op.claim_id}`
}

function set_val(ff, dt) {
//console.log('set_val', ff, dt);
    vals.value[ ff ]=dt

    if ('beg' === ff) {// одна дата - только за это число
      if (dt && !vals.value['end']) {
        vals.value['end'] = dt
      }
    } else if ('end' === ff) {
      if (dt && !vals.value['beg']) {
        vals.value['beg'] = dt
      }
    }

    vals.value.offset=0
    has_next_page.value=true
    vals.value.show_all=false
}

function reset() {
    vals.value=start_vals()
    reset_key.value=reset_key.value+1
}

function page_next() {
    if (wait.value) {// иначе offset станет невалидным
        return;
    }
    if (!vals.value.show_all) {
        vals.value.offset=vals.value.offset+1
//console.log('page_next', vals.value.offset)
    }
}

function page_all() {
    if (wait.value) {// иначе offset станет невалидным
        return;
    }
    vals.value.show_all=true;
    vals.value.offset=0;
//console.log('page_all', 'show_all=true', 'offset=0')
}

function refresh() {
//console.log('refresh')
    if (abort.value) {
        abort.value.abort()
    }
    abort.value=new AbortController()
    load_n_vals(vals.value, abort.value.signal).then(proc, proc)
}

function proc({data,rej,vals}) {
    abort.value=null;
    if (data) {
        isError.value=false
        if (0==vals.offset) {
            operations.value=data;
        }else{
            operations.value=operations.value.concat(data);
        }
        has_next_page.value=0==data.length ? false : true// не показываем далее если очередной запрос пуст
    }else{// reject
        isError.value=true
        has_next_page.value=true
    }
}

watch(
    vals,
    refresh,
    {
        deep: true,
    }
)

refresh()
</script>
